/**
 * Cart Handler – Badge Count Correction & Overlay Fix
 *
 * Badge count is rendered correctly server-side in header.liquid.
 * This script corrects the badge after AJAX cart changes (add/remove)
 * and fixes the cart overlay for spare parts.
 */
(function () {
  'use strict';

  function fmtPrice(cents) {
    cents = parseInt(cents, 10) || 0;
    if (typeof theme !== 'undefined' && theme.Shopify && theme.Shopify.formatMoney) {
      return theme.Shopify.formatMoney(cents, theme.money_format);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' DKK';
  }

  function updateBadge() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = 0;
        var hasSpareParts = false;
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          if (item.properties && item.properties._price) {
            count += 1;
            hasSpareParts = true;
          } else {
            count += item.quantity;
          }
        }
        if (!hasSpareParts) return;
        document.querySelectorAll('.cart-link__count').forEach(function (el) {
          el.textContent = count;
        });
      })
      .catch(function () {});
  }

  function fixOverlay() {
    var overlay = document.getElementById('cart-summary-overlay');
    if (!overlay) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var lastItem = cart.items.length > 0 ? cart.items[cart.items.length - 1] : null;
        if (!lastItem || !lastItem.properties || !lastItem.properties._price) return;

        var priceVal = lastItem.properties._price;
        var formatted = fmtPrice(priceVal);

        var linePrice = overlay.querySelector('.cart-summary-overlay__line-price');
        var mobileLinePrice = overlay.querySelector('.cart-summary-overlay__mobile-line-price');
        var unitPrice = overlay.querySelector('.cart-summary-overlay__unit-price');
        var mobileUnitPrice = overlay.querySelector('.cart-summary-overlay__mobile-unit-price');
        var qty = overlay.querySelectorAll('.cart-summary-overlay__quantity');

        if (linePrice) linePrice.textContent = formatted;
        if (mobileLinePrice) mobileLinePrice.textContent = formatted;
        if (unitPrice) unitPrice.textContent = formatted;
        if (mobileUnitPrice) mobileUnitPrice.textContent = formatted;
        qty.forEach(function (el) { el.textContent = '1'; });
      })
      .catch(function () {});
  }

  var overlayObserver = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      for (var j = 0; j < mutations[i].addedNodes.length; j++) {
        var node = mutations[i].addedNodes[j];
        if (node.nodeType === 1 && (node.id === 'cart-summary-overlay' || (node.querySelector && node.querySelector('#cart-summary-overlay')))) {
          fixOverlay();
          return;
        }
      }
    }
  });
  overlayObserver.observe(document.body, { childList: true, subtree: true });

  function delayedBadgeUpdate() {
    setTimeout(updateBadge, 500);
  }

  document.addEventListener('cart:refresh', delayedBadgeUpdate);
  document.documentElement.addEventListener('theme:cartchanged', delayedBadgeUpdate);
})();
